<mat-progress-bar *ngIf="isApiCommunicating$ | async" mode="indeterminate" style="position: absolute; width: 100vw"></mat-progress-bar>
<cml-header>
  <button type="button" matTooltip="Hlavní menu" matTooltipPosition="below" mat-button (click)="drawer.toggle()"><i class="cml-fw cml-lg cml-bars" [attr.active-color]="'cml-active-white'"></i></button>
</cml-header>

<div class="main-container">
  <mat-drawer-container class="main-drawer-container">
    <mat-drawer #drawer class="menu" mode="side" opened>
      <cml-menu></cml-menu>
    </mat-drawer>

    <div class="content">
      <!-- todo breadcrumb -->
      <router-outlet></router-outlet>
    </div>

  </mat-drawer-container>
</div>
